export class AppointmentTaken {

    private turn: string;
    private turnListinternalId: string;
    private turnLocation: string;
    private turnTicketHtml: string;
    private turnTicketText: string;

    constructor(turn?: string, turnListinternalId?: string, turnLocation?: string, turnTicketHtml?: string, turnTicketText?: string) { }

    public get Turn() {
        return this.turn;
    }
    public get TurnListinternalId() {
        return this.turnListinternalId;
    }
    public get TurnLocation() {
        return this.turnLocation;
    }
    public get TurnTicketHtml() {
        return this.turnTicketHtml;
    }
    public get TurnTicketText() {
        return this.turnTicketText;
    }

    public set Turn(turn) {
        this.turn = turn;
    }
    public set TurnListinternalId(turnListinternalId) {
        this.turnListinternalId = turnListinternalId;
    }
    public set TurnLocation(turnLocation) {
        this.turnLocation = turnLocation;
    }
    public set TurnTicketHtml(turnTicketHtml) {
        this.turnTicketHtml = turnTicketHtml;
    }
    public set TurnTicketText(turnTicketText) {
        this.turnTicketText = turnTicketText;
    }

}
